/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { PrintEntryPoint } from '@gh/common-shared-data';
import { date, DateFormat, entity, enumeration } from '@gh/core-data';

import { ContactDeliveryMethod } from '../contacts';
import { QuotationBase } from '../leads/quotation.dto';
import {
  LetterDto,
  LetterFinalVersionDto,
  QuotationPrintMethod,
  QuotationPrintRequestDto,
  QuotationPrintResponseDto,
} from './letter.dto';

export const LetterMapper = entity<LetterDto>({
  deliveryBy: enumeration(ContactDeliveryMethod),
  created: date(DateFormat.DateTime),
});

export const QuotationPrintRequestMapper = entity<QuotationPrintRequestDto>({
  type: enumeration(QuotationBase),
  entryPoint: enumeration(PrintEntryPoint),
  method: enumeration(QuotationPrintMethod),
});

export const QuotationPrintResponseMapper = entity<QuotationPrintResponseDto>({
  quoteDoc: LetterMapper,
  authorityDoc: LetterMapper,
  hpTopReport: LetterMapper,
});

export const LetterFinalVersionMapper = entity<LetterFinalVersionDto>({
  filledTemplate: LetterMapper,
});
